// extracted by mini-css-extract-plugin
export var carouselContainer = "B_t7 d_v d_G d_bd d_Y";
export var carouselContainerCards = "B_t8 B_t7 d_v d_G d_bd d_Y";
export var carouselContainerSides = "B_t9 d_v d_G d_Y";
export var prevCarouselItem = "B_vb d_v d_G d_Z d_j";
export var prevCarouselItemL = "B_vc B_vb d_v d_G d_Z d_j";
export var moveInFromLeft = "B_vd";
export var prevCarouselItemR = "B_vf B_vb d_v d_G d_Z d_j";
export var moveInFromRight = "B_vg";
export var selectedCarouselItem = "B_vh d_v d_G d_Y d_bd";
export var selectedCarouselItemL = "B_vj B_vh d_v d_G d_Y d_bd";
export var selectedCarouselItemR = "B_vk B_vh d_v d_G d_Y d_bd";
export var nextCarouselItem = "B_vl d_v d_G d_Z d_j";
export var nextCarouselItemL = "B_vm B_vl d_v d_G d_Z d_j";
export var nextCarouselItemR = "B_vn B_vl d_v d_G d_Z d_j";
export var arrowContainer = "B_vp d_G d_Z d_dz d_bk d_3 d_b0";
export var prevArrowContainer = "B_vq B_vp d_G d_Z d_dz d_bk d_3 d_b0";
export var prevArrowContainerHidden = "B_vr B_vq B_vp d_G d_Z d_dz d_bk d_3 d_b0 d_j";
export var nextArrowContainer = "B_vs B_vp d_G d_Z d_dz d_bk d_3 d_b0";
export var carouselContainerProducts = "B_vt";
export var nextArrowContainerHidden = "B_vv B_vs B_vp d_G d_Z d_dz d_bk d_3 d_b0 d_j";
export var arrow = "B_kG d_Z";
export var prevArrow = "B_vw B_kG d_Z";
export var nextArrow = "B_vx B_kG d_Z";
export var carouselIndicatorContainer = "B_vy d_v d_dv d_bk d_by d_bC d_bN d_bH d_Z";
export var btnsContainer = "B_vz d_v d_by d_bD";
export var carouselText = "B_vB d_dp d_by d_bC d_bN d_b0 d_dz d_cC";
export var carouselTextInactive = "B_vC B_vB d_dp d_by d_bC d_bN d_b0 d_dz d_cC";
export var indicator = "B_vD d_b6";
export var carouselIndicator = "B_vF B_vD d_b6";
export var carouselIndicatorSelected = "B_vG B_vD d_b6";
export var arrowsContainerTopRight = "B_vH d_Z d_bk d_bB";
export var arrowsContainerBottomLeft = "B_vJ d_Z d_bk d_bB";
export var arrowsContainerSides = "B_vK d_Z d_bk d_bB";
export var smallArrowsBase = "B_vL d_bS d_by d_bC d_bN d_b0 d_dz d_cC";
export var smallArrowContainer = "B_vM B_vL d_bS d_by d_bC d_bN d_b0 d_dz d_cC";
export var smallArrowContainerPrev = "B_vN B_vM B_vL d_bS d_by d_bC d_bN d_b0 d_dz d_cC";
export var smallArrowContainerSmall = "B_vP B_vL d_bS d_by d_bC d_bN d_b0 d_dz d_cC";
export var smallArrowContainerPrevSmall = "B_vQ B_vP B_vL d_bS d_by d_bC d_bN d_b0 d_dz d_cC";
export var icon = "B_pC";
export var iconSmall = "B_vR";
export var multipleWrapper = "B_vS d_bB d_bD d_bd";
export var multipleImage = "B_vT d_bB";
export var sidesPrevContainer = "B_vV B_vM B_vL d_bS d_by d_bC d_bN d_b0 d_dz d_cC d_fm d_Z d_bk d_cC";
export var sidesNextContainer = "B_vW B_vM B_vL d_bS d_by d_bC d_bN d_b0 d_dz d_cC d_fm d_Z d_bk d_cC";